/* ==========================================================================
   Kopstorm - Kit Finder banner (Wave 13)

   Three jobs, none of them load bearing. With this file blocked the banner is
   still a readable block with the first image and a working button.

   1. Resume label. Someone who already started the quiz in this session gets
      the resume label on the button instead of the normal one.
   2. Image rotation. Two or more images cross fade on a timer, with a circular
      progress ring bottom right that doubles as a next button. The timer pauses
      while the pointer is over the image and while the section is off screen.
   3. Hover effects. Magnetic pull towards the pointer and a ripple on click,
      both skipped when the visitor asks for reduced motion.
   ========================================================================== */

(function () {
  'use strict';

  var SEEN = 'data-kqb-ready';

  function readStore(key) {
    try {
      var raw = window.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function hasAnswers(store) {
    for (var name in store) {
      if (Object.prototype.hasOwnProperty.call(store, name) && store[name]) return true;
    }
    return false;
  }

  var REDUCED = false;
  try {
    REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    /* older browser, keep the motion */
  }

  function setupMedia(media) {
    var slides = Array.prototype.slice.call(media.querySelectorAll('[data-kqb-slide]'));
    var ring = media.querySelector('[data-kqb-ring]');
    var button = media.querySelector('[data-kqb-next]');
    var count = media.querySelector('[data-kqb-count]');
    var fx = media.querySelector('[data-kqb-fx]');
    var hover = media.getAttribute('data-kqb-hover') || 'none';
    var duration = parseInt(media.getAttribute('data-kqb-duration'), 10) || 5000;
    var index = 0;
    var timer = null;
    var paused = false;

    /* 2. Image rotation */
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-on', i === index);
      });
      if (count) count.textContent = index + 1 + '/' + slides.length;
      if (ring && !REDUCED) {
        /* Restarting the CSS animation keeps the ring in step with the timer */
        ring.style.animation = 'none';
        void ring.getBoundingClientRect();
        ring.style.animation = '';
      }
    }

    function start() {
      if (slides.length < 2 || timer || paused) return;
      timer = window.setInterval(function () {
        show(index + 1);
      }, duration);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function pause(state) {
      paused = state;
      if (button) button.classList.toggle('kqb-prog--paused', state);
      if (state) stop();
      else start();
    }

    if (button) {
      button.addEventListener('click', function () {
        stop();
        show(index + 1);
        start();
      });
    }

    if (slides.length > 1) {
      media.addEventListener('mouseenter', function () { pause(true); });
      media.addEventListener('mouseleave', function () { pause(false); });

      if ('IntersectionObserver' in window) {
        new window.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) start();
            else stop();
          });
        }, { threshold: 0.2 }).observe(media);
      } else {
        start();
      }
    }

    /* 3. Hover effects */
    if (REDUCED || hover === 'none') return;

    if (hover === 'magnetic' || hover === 'both') {
      media.addEventListener('mousemove', function (event) {
        var box = media.getBoundingClientRect();
        if (!box.width || !box.height) return;
        var dx = (event.clientX - box.left) / box.width - 0.5;
        var dy = (event.clientY - box.top) / box.height - 0.5;
        media.style.setProperty('--kqb-tx', (dx * 18).toFixed(1) + 'px');
        media.style.setProperty('--kqb-ty', (dy * 18).toFixed(1) + 'px');
      });
      media.addEventListener('mouseleave', function () {
        media.style.setProperty('--kqb-tx', '0px');
        media.style.setProperty('--kqb-ty', '0px');
      });
    }

    if (fx && (hover === 'ripple' || hover === 'both')) {
      media.addEventListener('pointerdown', function (event) {
        var box = media.getBoundingClientRect();
        var dot = document.createElement('span');
        dot.className = 'kqb-ripple';
        dot.style.setProperty('--kqb-rx', (event.clientX - box.left).toFixed(0) + 'px');
        dot.style.setProperty('--kqb-ry', (event.clientY - box.top).toFixed(0) + 'px');
        fx.appendChild(dot);
        window.setTimeout(function () {
          if (dot.parentNode) dot.parentNode.removeChild(dot);
        }, 950);
      });
    }
  }

  function setup(root) {
    if (root.getAttribute(SEEN) === 'true') return;
    root.setAttribute(SEEN, 'true');

    var storeKey = root.getAttribute('data-kqb-store') || 'anavrin_kit_finder';
    var resumeLabel = root.getAttribute('data-kqb-resume') || '';

    Array.prototype.slice.call(root.querySelectorAll('[data-kqb-media]')).forEach(setupMedia);

    /* 1. Resume label */
    if (resumeLabel && hasAnswers(readStore(storeKey))) {
      Array.prototype.slice.call(root.querySelectorAll('.kqb-cta .btn-text')).forEach(function (node) {
        /* The theme button holds a text node followed by the arrow icon, so
           only the text node is replaced and the icon stays in place. */
        var children = Array.prototype.slice.call(node.childNodes);
        for (var i = 0; i < children.length; i++) {
          if (children[i].nodeType === 3 && children[i].nodeValue.trim()) {
            children[i].nodeValue = resumeLabel;
            return;
          }
        }
      });
    }
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-kop-qb]')).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The theme editor re-renders the section on every setting change. */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-kop-qb]');
    if (root) setup(root);
  });
})();
